import type {
  NotificationSummary,
  NotificationRowData,
} from "@/api/notifications";

export function withAllRowsRead(
  summary: NotificationSummary,
): NotificationSummary {
  return {
    ...summary,
    count: summary.approvals.length,
    rows: summary.rows.map((row) => (row.read ? row : { ...row, read: true })),
  };
}

export function withRowsCleared(
  summary: NotificationSummary,
): NotificationSummary {
  return { ...summary, count: summary.approvals.length, rows: [] };
}

export function countsTowardTotal(row: NotificationRowData): boolean {
  return !row.read && !row.quiet;
}

export function withRowRead(
  summary: NotificationSummary,
  rowId: string,
): NotificationSummary {
  const row = summary.rows.find((candidate) => candidate.id === rowId);
  if (!row || row.read) return summary;
  return {
    ...summary,
    count: Math.max(0, summary.count - (countsTowardTotal(row) ? 1 : 0)),
    rows: summary.rows.map((candidate) =>
      candidate.id === rowId ? { ...candidate, read: true } : candidate,
    ),
  };
}

export function withoutRow(
  summary: NotificationSummary,
  rowId: string,
): NotificationSummary {
  const row = summary.rows.find((candidate) => candidate.id === rowId);
  if (!row) return summary;
  return {
    ...summary,
    count: Math.max(0, summary.count - (countsTowardTotal(row) ? 1 : 0)),
    rows: summary.rows.filter((candidate) => candidate.id !== rowId),
  };
}

export function withoutApproval(
  summary: NotificationSummary,
  approvalId: string,
): NotificationSummary {
  if (!summary.approvals.some((approval) => approval.id === approvalId))
    return summary;
  return {
    ...summary,
    count: Math.max(0, summary.count - 1),
    approvals: summary.approvals.filter(
      (approval) => approval.id !== approvalId,
    ),
  };
}

export function liveMembers(row: NotificationRowData): ReadonlySet<string> {
  return new Set(row.source === "notification" ? row.member_ids : []);
}
